module.exports = __webpack_public_path__ + "static/media/Copper_Medal_Icon.f8a4c22a.svg";